import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import http from 'axios'
import { withStyles } from '@mui/styles'
import { style } from 'styles'

import { ThemeProvider, createTheme } from '@mui/material/styles'
import { FeedBack, Loading } from 'components'
import Init from '../navigation/Init/Init'

function Start({ children }) {
	const dispatch = useDispatch()
	const { isStarted } = useSelector(state => state.ui)

	useEffect(() => {
		const addInterceptors = () => {
			http.interceptors.request.use(
				(request) => {
					dispatch({ type: 'startLoad@ui' })
					return (request)
				}
			)
			http.interceptors.response.use(
				(response) => {
					dispatch({ type: 'stopLoad@ui' })
					return response.data
				},
				(error) => {
					dispatch({ type: 'stopLoad@ui' })

					let message
					if (error.response == undefined) {
						message = 'Network error'
					} else {
						switch (error.response.status) {
							case 404:
								message = 'Service not found'
								break

							default:
								if (typeof error.response.data.message == 'undefined') {
									message = error.response.data
								} else {
									message = error.response.data.message
								}
								break
						}
					}

					dispatch({ type: 'setFeedback@ui', message: message, color: 'error', hideDuration: 5000 })
					return Promise.reject(error)
				}
			)
		}

		const initialLoad = async() => {
			let promises = []
			promises.push(http.get(`${window.__endpoint}/api/categories/listAll`))
			promises.push(http.get(`${window.__endpoint}/api/booking/loadServices`))
			promises.push(http.get(`${window.__endpoint}/api/shop/load`))
			promises.push(http.get(`${window.__endpoint}/api/products/offers`))

			Promise.all(promises).then(returns => {
				dispatch({ type: 'loadCategories@products', data: returns[0] })
				dispatch({ type: 'loadServices@services', data: returns[1] })
				dispatch({ type: 'loadData@shop', data: returns[2] })
				dispatch({ type: 'loadOffers@offers', data: returns[3] })
				dispatch({ type: 'setStarted@ui' })
			})
		}

		addInterceptors()
		initialLoad()
	}, [])

	const theme = createTheme({
		palette: {
			// https://material-ui.com/customization/color/
			// primary - used to represent primary interface elements for a user.
			// secondary - used to represent secondary interface elements for a user.
			// error - used to represent interface elements that the user should be made aware of.
			// warning - used to represent potentially dangerous actions or important messages.
			// info - used to present information to the user that is neutral and not necessarily important.
			// success - used to indicate the successful completion of an action that user triggered.
			primary: {
				light: window.__colorMainLight,
				main: window.__colorMain,
				dark: window.__colorMainDark,
			},
			secondary: {
				light: window.__colorSecondaryLight,
				main: window.__colorSecondary,
				dark: window.__colorSecondaryDark,
			},
		},
		typography: { useNextVariants: true },
	})

	// const classes = useStyles()
	return (<ThemeProvider theme={theme}>
		{isStarted && children}
		{!isStarted && <Init />}
		<FeedBack />
		<Loading />
	</ThemeProvider>)
}

export default Start
